import React from 'react';

export const ElementsSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="256"
    height="253"
    viewBox="0 0 256 253"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_918_490)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M144.391 143.802H255.679V253.495H144.391V143.802ZM158.391 157.802V239.495H241.679V157.802H158.391Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M194.452 13.4635C168.37 13.4635 147.226 34.6076 147.226 60.6901C147.226 86.7726 168.37 107.917 194.452 107.917C220.535 107.917 241.679 86.7726 241.679 60.6901C241.679 34.6076 220.535 13.4635 194.452 13.4635ZM133.226 60.6901C133.226 26.8756 160.638 -0.536499 194.452 -0.536499C228.267 -0.536499 255.679 26.8756 255.679 60.6901C255.679 94.5046 228.267 121.917 194.452 121.917C160.638 121.917 133.226 94.5046 133.226 60.6901Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.0646 0.438843L132.056 114.739H0.0732422L66.0646 0.438843ZM24.322 100.739H107.807L66.0646 28.4388L24.322 100.739Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.9309 146.317L127.368 200.529L96.137 254.86L33.4697 254.979L2.03303 200.767L33.2636 146.436L95.9309 146.317ZM41.3731 160.421L18.1988 200.737L41.526 240.964L88.0275 240.876L111.202 200.56L87.8746 160.333L41.3731 160.421Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default ElementsSvg;
